import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MaskGuard } from './mask.guard';
import {
  LandingComponent,
  ForwarderMask1Component,
  GhaMask4Component,
  ChaForwarderMask3Component,
  ChaMask2Component
} from './views';

const routes: Routes = [{
  path: '',
  component: LandingComponent
}, {
  path: 'mask1',
  component: ForwarderMask1Component,
  canActivate: [MaskGuard]
}, {
  path: 'mask2',
  component: ChaMask2Component,
  canActivate: [MaskGuard]
}, {
  path: 'mask4',
  component: GhaMask4Component,
  canActivate: [MaskGuard]
}, {
  path: 'mask3',
  component: ChaForwarderMask3Component,
  canActivate: [MaskGuard]
}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
